import { useContext } from 'react'

import { LayoutContext } from './LayoutContext'

const useLayout = () => {
  const { state, dispatch } = useContext(LayoutContext)

  return {
    ...state,
    setFontSize: payload => dispatch({ type: 'SET_FONT_SIZE', payload }),
    setContrastMode: payload => dispatch({ type: 'SET_CONTRAST_MODE', payload }),
    setAccessibilityMode: payload => dispatch({ type: 'SET_ACCESSIBILITY_MODE', payload }),
    setAppData: payload => dispatch({ type: 'SET_APP_DATA', payload }),
    resetLayout: () => dispatch({ type: 'RESET_LAYOUT' })
  }
}

export default useLayout
